export class OverviewHtml{
  overviewskin (){
    return `
        <div class="default-container">
          <div class="container-content">
            <h2 class="title-heading">Fleet Manager</h2>
            <p class="sub-description">Real time data and power monitoring fleet manager</p>
            <div class="input-group appended-icon max-w-500 mt-20">
                <input type="text" id="filterInput" placeholder="Filter sites...">
                <div class="input-icon">
                    <span class="iconify" data-icon="mi:filter" data-inline="false"></span>
                </div>
            </div>
          </div>
          <div id="siteGrid" class="site-grid">
            <!-- Site cards will be rendered here -->
          </div>
        </div>
        <div class="superadmin-only bottom-bar d-flex justify-content-between align-items-center ">
          <p>V.01.24</p>
          <div class="d-flex gap-15">
            <button class="btn btn--white" id="addSiteBtn">Add New Site</button>
          </div>
        </div>
        <!-- Modal Container -->
        <div id="siteModal" class="modal hidden">
          <div class="modal-content">
            <span class="close-btn">&times;</span>
            <h3 id="modalTitle">Add / Edit Site</h3>
            <form id="siteForm" class="site-form">
              <input type="hidden" id="siteId">
              <div class="form-group">
                <label>Site Name</label>
                <input type="text" id="siteName" required>
              </div>
              <div class="form-group">
                <label>Location</label>
                <input type="text" id="siteLocation" required>
              </div>
              <div class="form-group">
                <label>IP</label>
                <input type="text" id="siteIp" required>
              </div>
              <div class="form-group">
                <label>Port</label>
                <input type="number" id="sitePort" required>
              </div>
              <button type="submit" class="btn btn--primary">Save</button>
            </form>
          </div>
        </div>
    `;
  }
}